module.exports = __webpack_public_path__ + "static/img/banner.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/banner.png
// module id = zXPx
// module chunks = 1